export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            投稿爆料
          </h2>
        </div>

        <div className="bg-background-200 rounded-2xl p-6 md:p-10">
          <div className="max-w-2xl mx-auto text-center">
            <div className="w-14 h-14 mx-auto mb-5 rounded-2xl bg-primary-500/15 flex items-center justify-center">
              <i className="ri-send-plane-fill text-primary-400 text-2xl"></i>
            </div>

            <h3 className="font-heading text-xl font-bold text-foreground-200 mb-3">
              你有料，我有平台
            </h3>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8">
              如果你掌握任何不为人知的真实吃瓜线索、隐秘八卦或新爆料内容，欢迎通过以下方式联系我们。暗网吃瓜严格保护爆料人隐私，所有投稿均可匿名处理。你的每一次爆料，都可能成为下一个全網熱議的焦點话题。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="bg-background-100 rounded-xl p-4">
                <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-accent-500/15 flex items-center justify-center">
                  <i className="ri-mail-line text-accent-400 text-xl"></i>
                </div>
                <div className="text-sm font-medium text-foreground-300 mb-1">爆料邮箱</div>
                <div className="text-xs text-foreground-500">tip@anwangchigua.com</div>
              </div>

              <div className="bg-background-100 rounded-xl p-4">
                <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-secondary-500/15 flex items-center justify-center">
                  <i className="ri-wechat-line text-secondary-400 text-xl"></i>
                </div>
                <div className="text-sm font-medium text-foreground-300 mb-1">微信投稿</div>
                <div className="text-xs text-foreground-500">awcg_tip</div>
              </div>

              <div className="bg-background-100 rounded-xl p-4">
                <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-primary-500/15 flex items-center justify-center">
                  <i className="ri-discuss-line text-primary-400 text-xl"></i>
                </div>
                <div className="text-sm font-medium text-foreground-300 mb-1">论坛直发</div>
                <div className="text-xs text-foreground-500">暗网吃瓜论坛爆料专区</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}